import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=819cd794&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=819cd794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819cd794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819cd794')) {
      api.createRecord('819cd794', component.options)
    } else {
      api.reload('819cd794', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=819cd794&scoped=true&", function () {
      api.rerender('819cd794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/contractors/Edit.vue"
export default component.exports